var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 292 292"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 138,
    r: 142,
    fill: "#5FA378",
    stroke: "#4C8661",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.656 192.415 207.561 77.51l23.57 23.57-114.905 114.905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.708 154.466 23.57-23.57 61.518 61.519-23.57 23.57z"
  })))));
};
export default SvgCheckmark;